import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styles/Chapters.css";
import { Modal } from "react-bootstrap";

import Slider from "react-slick";
import Member from "../components/Membership/Member";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import HyderabadImg from "../assets/hyd.png";
import AmaravathiImg from "../assets/amaravthi.png";
import KakinadaImg from "../assets/gujrat.png";
import BangaloreImg from "../assets/karnataka.png";
import TirupathiImg from "../assets/tamilnadu.png";
import MumbaiImg from "../assets/maha.png";
import  ArunachalImg from "../assets/Arunachal.png";
import AssamImg  from "../assets/Assam.png";
import BiharImg from "../assets/Bihar.png";
import ChhattisgarhImg from "../assets/Chhattisgarh.png";
import GoaImg from "../assets/Goa.png";
import HarayanaImg from "../assets/Haryana.png";
import HimachaalPradeshImg from "../assets/Himachal.png";
import JharkhandImg from "../assets/Jharkhand.png";
import KeralaImg from "../assets/Kerala.png"
import MadhyaPradeshImg from "../assets/Madhyapradesh.png";
import ManipurImg from "../assets/Manipur.png";
import MeghalayaImg from "../assets/Meghalaya.png";
import MizoramImg from "../assets/Mizoram.png";
import NagalandImg from "../assets/Nagaland.png";
import OdishaImg from "../assets/Odisha.png";
import PunjabImg from "../assets/Punjab.png";
import RajasthanImg from "../assets/Rajasthan.png";
import SikkimImg from "../assets/Sikkim.png";
import TripuraImg from "../assets/Tripura.png";
import UttarpradeshImg from "../assets/Uttarpradesh.png";
import UttarkhandImg from "../assets/uttarakhand.png";
import WestbengalImg from "../assets/westbengal.png";


const chapters = [
  {
    name: "Telangana",
    members: "more than 40",
    icon: HyderabadImg,
    btnColor: "danger",
  },
  {
    name: "Andhra Pradesh",
    members: "more than 20",
    icon: AmaravathiImg,
    btnColor: "danger",
  },
  {
    name: "Gujarat",
    members: "more than 20",
    icon: KakinadaImg,
    btnColor: "danger",
  },
  {
    name: "Karnataka",
    members: "more than 30",
    icon: BangaloreImg,
    btnColor: "danger",
  },
  {
    name: "Tamil Nadu",
    members: "more than 20",
    icon: TirupathiImg,
    btnColor: "danger",
  },
 
  {
    name: "Maharashtra",
    members: "more than 10",
    icon: MumbaiImg,
    btnColor: "danger",
  },
  
   {
    name: "Arunachal Pradesh",
    members: "more than 30",
    icon: ArunachalImg,
    btnColor: "danger",
  },
    {
    name: "Assam",
    members: "more than 20",
    icon: AssamImg,
    btnColor: "danger",
  },
   {
    name: "Bihar",
    members: "more than 10",
    icon: BiharImg,
    btnColor: "danger",
  },
   {
    name: "Chhattisgarh",
    members: "more than 30",
    icon: ChhattisgarhImg,
    btnColor: "danger",
  },
   {
    name: "Goa",
    members: "more than 10",
    icon: GoaImg,
    btnColor: "danger",
  },
   {
    name: "Harayana",
    members: "more than 20",
    icon: HarayanaImg,
    btnColor: "danger",
  },
   {
    name: "Himachaal Pradesh",
    members: "more than 30",
    icon: HimachaalPradeshImg,
    btnColor: "danger",
  },
   {
    name: "Jharkhand",
    members: "more than 20",
    icon: JharkhandImg,
    btnColor: "danger",
  },
   {
    name: "Kerala",
    members: "more than 10",
    icon: KeralaImg,
    btnColor: "danger",
  },
  
  
   {
    name: "Madhya Pradesh",
    members: "more than 30",
    icon: MadhyaPradeshImg,
    btnColor: "danger",
  },
   {
    name: "Manipur",
    members: "more than 20",
    icon: ManipurImg,
    btnColor: "danger",
  },
   {
    name: "Meghalaya",
    members: "more than 10",
    icon: MeghalayaImg,
    btnColor: "danger",
  },
   {
    name: "Mizoram",
    members: "more than 30",
    icon: MizoramImg,
    btnColor: "danger",
  },
   {
    name: "Nagaland",
    members: "more than 20",
    icon: NagalandImg,
    btnColor: "danger",
  },
   {
    name: "Odisha",
    members: "more than 10",
    icon: OdishaImg,
    btnColor: "danger",
  },
   {
    name: "Punjab",
    members: "more than 30",
    icon: PunjabImg,
    btnColor: "danger",
  },
   {
    name: "Rajasthan",
    members: "more than 20",
    icon: RajasthanImg,
    btnColor: "danger",
  },
   {
    name: "Sikkim",
    members: "more than 10",
    icon: SikkimImg,
    btnColor: "danger",
  },
  {
    name: "Tripura",
    members: "more than 30",
    icon: TripuraImg,
    btnColor: "danger",
  },
 
  {
    name: "Uttar Pradesh",
    members: "more than 20",
    icon: UttarpradeshImg,
    btnColor: "danger",
  },
  {
    name: "Uttarkhand",
    members: "more than 10",
    icon: UttarkhandImg,
    btnColor: "danger",
  },
   {
    name: "West Bengal",
    members: "more than 30",
    icon: WestbengalImg,
    btnColor: "danger",
  },
];

export default function Chapters() {

    // MEMBERSHIP MODAL
    const [showMember, setShowMember] = useState(false);
    const handleShowMember = () => setShowMember(true);
    const handleCloseMember = () => setShowMember(false);
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,     
  slidesToScroll: 1,   
  responsive: [
    {
      breakpoint: 992,  
      settings: { slidesToShow: 2, slidesToScroll: 1 }
    },
    {
      breakpoint: 768,  
      settings: { slidesToShow: 1, slidesToScroll: 1 }
    },
    {
      breakpoint: 576,  // MOBILE (360×740)
      settings: { slidesToShow: 1, slidesToScroll: 1 }
    },
  ]
};


  return (
    <div className="container  p-5 h-1oovh " id="chapters">
      <div className="text-center mb-4">
        <h3 className="section-title mt-5"><u>CHAPTERS</u></h3>
      </div>
        <Slider {...settings}>
        {chapters.map((chapter, index) => (
          <div className="p-3" key={index}>
            <div className="chapter-card text-center p-4 h-100">
              <div className="icon-container mb-3">
                <img
                  src={chapter.icon}
                  alt={chapter.name}
                  className="chapter-icon"
                />
              </div>
              <h5 className="chapter-title">{chapter.name}</h5>
              <p className="chapter-members">
                This chapter has {chapter.members} members
              </p>
              <button className={`btn btn-${chapter.btnColor} get-btn`}
              onClick={handleShowMember}>
                Get-Membership
              </button>
            </div>
          </div>
        ))}
      </Slider>

       {/* MEMBERSHIP MODAL */}
      <Modal show={showMember} onHide={handleCloseMember} centered size="lg" backdrop="static" className="membership-modal">
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold">Membership Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Member />
        </Modal.Body>
      </Modal>

    </div>
  );
}
